import {NgModule} from '@angular/core';



import {AjudaPanelComponent} from './ajuda-panel.component';
import {AjudaModule} from '../../../../ajuda/ajuda.module';

@NgModule({
    imports: [
    AjudaModule,
    AjudaPanelComponent,
],
    exports: [
        AjudaPanelComponent
    ]
})
export class AjudaPanelModule
{
}
